
import { action } from "mobx";
import React, { Component } from "react";
import { FieldRenderProps } from "react-final-form";

import { PromptContext, PromptManager } from "@inst_proserv/toolkit";
import { Field, ImageField, ImageFieldAdapter, showFormPrompt } from "@inst_proserv/finalform-instui";

import { ProfileHeader } from "../../../components/ProfileHeader";

export class AvatarEditHeader extends Component<{
    username: string;
} & FieldRenderProps<any>> {
    static contextType = PromptContext;
    context: PromptManager;

    @action.bound
    async handleEditClicked() {
        const added = await showFormPrompt<any>(this.context, <>
            <Field name="image" component={ImageField} adapter={ImageFieldAdapter} />
        </>, {
            title: `Profile Image`,
            saveButton: "Select Image",
        })
        if (added) {
            this.props.input.onChange(added.image);
        }
    }

    get avatar() {
        return ImageField.getImageURL(this.props.input.value) || "http://canvas.instructure.com/images/messages/avatar-50.png";
    }

    render() {
        return <ProfileHeader
            username={this.props.username}
            avatar={this.avatar}
            onAvatarChange={this.handleEditClicked}
        />
    }
}
